// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - SDKMCPStream
export class MCPStream {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(data) {
        this.id = data.id;
        this.projectFeatureId = data.projectFeatureId;
        this.projectDocumentId = data.projectDocumentId;
    }
    toRemote() {
        return {
            id: this.id,
            projectFeatureId: this.projectFeatureId,
            projectDocumentId: this.projectDocumentId,
        };
    }
}
